import React from "react";
import { LOGO_URL } from "../lib/calc";

export default function Topbar({ rightSlot }) {
  return (
    <header className="fl-topbar" data-testid="fl-topbar">
      <a href="/" style={{ display: "flex", alignItems: "center", gap: 12, textDecoration: "none" }}>
        <img className="logo" src={LOGO_URL} alt="Finlightenment" data-testid="fl-logo" />
      </a>
      <div className="badge-pill" data-testid="fl-tagline">
        Financial Enlightenment Awaits<sup style={{ fontSize: 8, marginLeft: 2 }}>™</sup>
      </div>
      {rightSlot}
    </header>
  );
}
